export const COLLECTION_PAYMENT_COUNT = 3

export type ProfileMediaTabs = 'all' | 'public' | 'private'
